export default {
	action: "Transferir propiedad",
	confirmTitle: "Transferir propiedad",
	confirmMessage:
		"{name} recibirá una solicitud para convertirse en Propietario; si acepta, usted pasa a Administrador.",
	confirm: "Enviar solicitud",
	requested: "Solicitud enviada; esperando la respuesta de {name}.",
	pendingSent: "Transferencia a {name} esperando respuesta hasta {date}.",
	cancel: "Cancelar solicitud",
	canceled: "Solicitud cancelada.",
	pageTitle: "Transferencia de propiedad",
	pendingReceived: "{name} quiere transferirle la propiedad de {temple}.",
	explanation: "Al aceptar, usted pasa a ser el Propietario, y {name} sigue como Administrador.",
	expiresAt: "La solicitud es válida hasta {date}.",
	accept: "Aceptar",
	decline: "Rechazar",
	acceptedRelogin: "Transferencia completada: cierre sesión y vuelva a entrar para usar el acceso de Propietario.",
	accepted: "Ahora usted es el Propietario del templo.",
	declined: "Solicitud rechazada.",
	none: "No hay ninguna transferencia de propiedad pendiente.",
	banner: "Recibió una solicitud de transferencia de la propiedad del templo.",
	viewRequest: "Ver solicitud",
	error: "No se pudo completar; inténtelo de nuevo.",
};
